import React from 'react'
import { useSelector } from 'react-redux'
import { Dropdown } from 'primereact/dropdown'
import { selectAllAssets } from 'providers/AssetLoader/store/selectors'

/**
 * Membership Type filter template that gets options from assets
 * @param {object} options - Filter options from PrimeReact column
 */
const MembershipTypeFilterTemplate = ({ options }) => {
    const assets = useSelector(selectAllAssets)
    const membershipTypes = assets?.membershipTypes || []
    
    const dropdownOptions = [
        { label: 'Empty', value: '__EMPTY__' },
        ...membershipTypes
            .filter(mt => mt.description !== 'Composite') // Exclude Composite membership type
            .map(mt => ({
                label: mt.description,
                value: mt.description
            }))
    ]
    return (
        <Dropdown
            value={options.value}
            options={dropdownOptions}
            optionLabel="label"
            optionValue="value"
            onChange={(e) => options.filterCallback(e.value, options.index)}
            placeholder="Select Membership Type"
            className="p-column-filter"
            showClear
        />
    )
}

export default MembershipTypeFilterTemplate
